"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styles_1 = require("@mui/material/styles");
const components_1 = tslib_1.__importDefault(require("./components"));
const palette_1 = tslib_1.__importDefault(require("./palette"));
const typography_1 = tslib_1.__importDefault(require("./typography"));
function generateTheme(theme) {
    const newPalette = (0, palette_1.default)(theme);
    const muiTheme = (0, styles_1.createTheme)({
        palette: newPalette,
        components: (0, components_1.default)(newPalette, theme),
        typography: (0, typography_1.default)(theme),
        spacing: theme.spacing.fn,
        breakpoints: {
            values: Object.keys(theme.breakpoints).reduce((acc, key) => {
                if (['up', 'down'].includes(key))
                    return acc;
                return Object.assign(Object.assign({}, acc), { [key]: Number(theme.breakpoints[key].replace('px', '')) });
            }, {})
        }
    });
    Object.keys(theme).forEach(key => {
        if (!muiTheme[key]) {
            muiTheme[key] = theme[key];
            return;
        }
        Object.keys(theme[key]).forEach(childKey => {
            if (key === 'breakpoints' && ['up', 'down'].includes(childKey))
                return;
            muiTheme[key][childKey] = theme[key][childKey];
        });
    });
    return muiTheme;
}
exports.default = generateTheme;
